import { useState, useEffect, useMemo } from 'react';
import LevelService from '../../../../services/level_service';

const Profile = (vm) => {
  const [levels, setLevels] = useState([])

  const loadLevels = async () => {
    vm.setLoading(true);
    try {
      const levs = await LevelService.getAll();
      if (vm.logout(levs)) return;
      setLevels(levs || []);
    } catch (e) {
      vm.message(e?.message || e, "error");
    } finally {
      vm.setLoading(false);
    }
  }

  useEffect(() => {loadLevels()}, [])

  const numLevels = levels.length;

  const insignias = useMemo(() => {
    return levels?.map((lev) => ({
      insignia: lev?.Insignia,
      active: Number(vm.score) >= lev.Minimum,
    }));
  }, [levels, vm.score]);

  const level = useMemo(() => {
    // Sin puntaje cargado no se asume ningún nivel
    if (!levels.length || Number.isNaN(Number(vm.score))) return null;
    const foundLevel = levels.find(
      (lev) => Number(vm.score) >= lev?.Minimum && Number(vm.score) <= lev?.Maximum
    );
    return foundLevel || levels[levels.length - 1];
  }, [levels, vm.score]);

  return {
    level,
    numLevels,
    insignias
  }
}

export default Profile;
